import { request } from "lib/request"
import { all, call, put, takeLatest } from "redux-saga/effects"
import { CustomerApi, ResponseSignup } from "types/payload"
import { Action, GFlow, GWatcher } from "types/redux"
import { SIGNUP_REQUEST, CHECK_EXISTING_REGISTERED_PHONE } from "./constants"
import config from "react-global-configuration"
import signupActions from "./actions"
import { SET_CUSTOMER } from "client/services/constants"
import verifyPhoneActions from "containers/VerifyPhone/services/actions"
import Compliance, { formatCustomerINSPayload } from "lib/api-compliance"
import { Customer } from "types/entity"
import { ERROR_API } from "types/error"

/*
 *  API REQUESTS
 */
export async function signupApi(payload: CustomerApi): Promise<ResponseSignup> {
  return await request(config.get("patient.signup"), {
    method: "POST",
    payload,
  })
}
/*
 * FLOWS
 */
function* signupFlow({ payload }: Action<CustomerApi>): GFlow<ResponseSignup> {
  const formattedPayload = formatCustomerINSPayload(payload);
  try {
    const response: ResponseSignup = yield call(signupApi, formattedPayload)
    if (response) {
      yield all([
        // L'api ne nous renvoie pas le patient
        put({
          type: SET_CUSTOMER,
          payload: {
            ...new Compliance<CustomerApi, Customer>({
              ...formattedPayload,
              is_verified: false,
            }).please(),
          },
        }),
        put(verifyPhoneActions.setSignupPayload(formattedPayload)),
        put(signupActions.success()),
      ])
    }
  } catch (error) {
    console.error(error, {
      route: config.get("patient.signup")
    })
    yield all([put(signupActions.error(error as string))])
  }
}

function* checkExistingRegisteredPhoneFlow({ payload }: Action<{ email: string; phone: string }>): any {
  try {
    const res: Response = yield fetch('/api/public/customers/v1/existing/phone', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        'X-User-Token': sessionStorage.getItem('X-USER-Token') || '',
      },
    })
    if (res.status === ERROR_API.NOT_FOUND) {
      yield put(signupActions.setAlreadyExistingPhone(null))
    }
    if (res.status === ERROR_API.PHONE_EXISTING_ERROR) {
      yield put(signupActions.setAlreadyExistingPhone(payload?.phone))
    }
  } catch (error) {
    console.error('checkExistingRegisteredPhone error', error)
    yield put(signupActions.setAlreadyExistingPhone(null))
  }
}

function* signupWatcher(): GWatcher {
  yield takeLatest(SIGNUP_REQUEST, signupFlow)
  yield takeLatest(CHECK_EXISTING_REGISTERED_PHONE, checkExistingRegisteredPhoneFlow)
}

export default signupWatcher
